import { Component, effect, input } from "@angular/core";
import { RoundedPipe } from "ev-core";
import { EvTooltipModule } from "ev-tooltip";
import { EvArrowChoiceComponent } from "src/app/shared-components/ev-arrow-choice/ev-arrow-choice.component";
import { DemographyTooltip } from "../buyer-demography.component";

@Component({
    selector: "buyer-origin",
    imports: [RoundedPipe, EvTooltipModule, EvArrowChoiceComponent], 
    templateUrl: "./buyer-origin.component.html",
    styleUrl: "./buyer-origin.component.scss",
})
export class BuyerOriginComponent {
    graphData = input<any[]>([]);
    graphTotalNum = input<number>(null);
    expanded = input<boolean>(false);
    councilExpanded = input<boolean>(false);
    isVacationHome = input<boolean>(false);

    showBuyers: boolean = false;
    changeMatrixTooltip: DemographyTooltip;
    countyIndex: number[] = [];
    countyData: GraphDoubleArray[] = [];
    districtData: GraphArray[][] = [];
    districtTotal: number[][] = [];
    areaData: GraphArray[][] = [];
    areaTotal: number[][] = [];
    CountyView: Array<GraphValue> = [];
    countyTotal: number = 0;
    councilTotal: number[] = [];

    constructor() {
        this.setupTooltipTexts();
        effect(() => {
            const data = this.graphData();
            this.countyIndex = [];
            this.countyData = [];
            this.districtData = [];
            this.districtTotal = [];
            this.areaData = [];
            this.areaTotal = [];
            this.CountyView = [];
            this.countyTotal = 0;
            this.councilTotal = [];
            if (data?.length) {
                this.splitUpArray(data);
            }
        });
    }

    private setupTooltipTexts() {
        this.changeMatrixTooltip = {
            show: false,
            header: "Hvor kommer kjøperne fra? ",
            info: [
                "Tallene er basert på den geografiske tilhørigheten til boligen som eier eide inntil 6 måneder før, eller solgte innen 6 måneder etter " +
                    "hjemmelsovergang til denne. Eiere som eide flere eiendommer er tatt ut av statistikken. Tallene gjelder den enkelte hjemmelshaver der " +
                    "hjemmelsovergangen gjelder 100% av boligen. Vi teller kun eiere der vi kjenner til at eier hadde en annen bolig når denne ble overtatt. " +
                    "Grunnlag er antall eiere som oppfyller kriteriene.\n",
                "Eksempel:A og B kjøper en bolig sammen og tinglyser 50% eierandel hver. B flytter ut og selger sin andel tilbake til A. C flytter så inn og " +
                    "tinglyser en 30% eierandel som er kjøpt fra A. A og C eier boligen i dag. I dette tilfellet telles A og B som telles i tallene for endring " +
                    "av boligtype dersom A og B eide bolig fra før (innen +/-6 måneder). Dette er uavhengig av om de eide samme bolig eller om de eide en hver.",
                "Du kan velge mellom å se prosentandeler eller antall ved å klikke på henholdsvis % eller Antall",
            ],
        };
    }

    private splitUpArray(buyerData: any[]) {
        buyerData.forEach((data) => {
            data.toggle = false;
            if (data.Level === 1) {
                this.countyIndex.push(buyerData.indexOf(data));
                this.CountyView.push(data);
            }
        });

        this.countyTotal = this.CountyView.reduce((a, b) => a + (b["Num"] || 0), 0);
        for (let index = 0; index < this.countyIndex.length; index++) {
            this.countyData[index] = [];
            const council = buyerData.slice(this.countyIndex[index], this.countyIndex[index + 1]).filter((data) => data.Level === 2);
            this.councilTotal.push(council.reduce((a, b) => a + (b["Num"] || 0), 0));
            this.countyData[index].push(council as GraphArray);
        }
        for (let index = 0; index < this.countyIndex.length; index++) {
            this.districtData[index] = [];
            this.areaData[index] = [];
            this.areaTotal[index] = [];
            this.districtTotal[index] = [];

            for (let j = 0; j < this.countyData[index].length; j++) {
                let areaOther = [];
                let districtOther = [];
                for (let i = 0; i < this.countyData[index][j].length; i++) {
                    let areas;
                    if (this.countyData[index][j][i + 1] != null) {
                        areas = buyerData.slice(buyerData.indexOf(this.countyData[index][j][i]), buyerData.indexOf(this.countyData[index][j][i + 1]));
                    } else {
                        if (index === this.countyIndex.length - 1) {
                            areas = buyerData.slice(buyerData.indexOf(this.countyData[index][j][i]));
                        } else {
                            if (this.countyData[index + 1][j][i] != null) {
                                areas = buyerData.slice(buyerData.indexOf(this.countyData[index][j][i]), buyerData.indexOf(this.countyData[index + 1][j][0]));
                            } else {
                                areas = buyerData.slice(buyerData.indexOf(this.countyData[index][j][i]), buyerData.indexOf(this.countyData[index + 1][j][0]));
                            }
                        }
                    }

                    if (areas.length > 5) {
                        this.districtData[index].push(areas.filter((data) => data.Level === 3).slice(0, 5) as GraphArray);

                        districtOther = areas.filter((data) => data.Level === 3).slice(5);
                        if (districtOther.reduce((a, b) => a + (b["Num"] || 0), 0) > 0) {
                            this.districtData[index][i].push({
                                Name: "Andre",
                                Level: 3,
                                LevelName: "Bydel",
                                Num: districtOther.reduce((a, b) => a + (b["Num"] || 0), 0),
                            });
                            this.districtTotal[index].push(districtOther.length);
                        }
                        this.areaData[index].push(areas.filter((data) => data.Level === 4).slice(0, 5) as GraphArray);
                        areaOther = areas.filter((data) => data.Level === 4).slice(5);
                        if (areaOther.reduce((a, b) => a + (b["Num"] || 0), 0) > 0) {
                            this.areaData[index][i].push({
                                Name: "Andre",
                                Level: 4,
                                LevelName: "Grunnkretser",
                                Num: areaOther.reduce((a, b) => a + (b["Num"] || 0), 0),
                            });
                            this.areaTotal[index].push(areaOther.length);
                        }
                    } else if (areas.length <= 5 && areas.length > 1) {
                        this.districtData[index].push(areas.filter((data) => data.Level === 3).slice(0, areas.length) as GraphArray);
                        this.areaData[index].push(areas.filter((data) => data.Level === 4).slice(0, areas.length) as GraphArray);
                    } else {
                        if (i === this.countyData[index][j].length - 1) {
                            this.districtData[index].push(
                                buyerData.slice(buyerData.indexOf(this.countyData[index][j][i])).filter((data) => data.Level === 3) as GraphArray,
                            );
                            this.areaData[index].push(
                                buyerData.slice(buyerData.indexOf(this.countyData[index][j][i])).filter((data) => data.Level === 4) as GraphArray,
                            );
                        } else {
                            this.districtData[index].push(areas.filter((data) => data.Level === 3) as GraphArray);
                            this.areaData[index].push(areas.filter((data) => data.Level === 4) as GraphArray);
                        }
                    }
                }
            }
        }
    }

    
    buyerNumberChanged(index: number): void {
        if (index == 0) this.showBuyers = false;
        //Percent
        else if (index == 1) this.showBuyers = true;
        //Values
        else throw "Option not handled";
    }

    toggleExpanded(index: number): void {
        this.CountyView[index].toggle = !this.CountyView[index].toggle;
    }

    toggleExpandedCouncil(countyIndex: number, index: number): void {
        this.countyData[countyIndex][0][index].toggle = !this.countyData[countyIndex][0][index].toggle;
    }
}

export interface GraphValue {
    Name: string;
    Level: number;
    LevelName: string;
    Num: number;
    toggle?: boolean;
}

interface GraphArray extends Array<GraphValue> {
    toggle: boolean;
}
interface GraphDoubleArray extends Array<GraphArray> {
    toggle?: boolean;
}
